import { gql } from '@apollo/client';

// Lightweight query for just stores (used for second role-based call)
export const HOMEPAGE_SEARCH_STORES_ONLY = gql`
  query HomepageSearchStoresOnly($search: String, $storeRoles: [UserRole!]) {
    stores(
      storeRoles: $storeRoles
      input: {
        orderBy: socialFollowerCount
        direction: DESC
        limit: 10
        searchTerm: $search
      }
    ) {
      entities {
        id
        lastName
        firstName
        role
        slug
        storeDetails {
          id
          storeName
          storeTitle
          avatarURL
        }
        sports {
          id
          name
        }
      }
    }
  }
`;

export const HOMEPAGE_SEARCH = gql`
  query HomepageSearch($search: String) {
    stores(
      storeRoles: [Athlete, Organization, ContentCreator]
      input: {
        orderBy: socialFollowerCount
        direction: DESC
        limit: 10
        searchTerm: $search
      }
    ) {
      entities {
        id
        lastName
        firstName
        role
        slug
        storeDetails {
          id
          storeName
          storeTitle
          avatarURL
        }
        sports {
          id
          name
        }
      }
    }
    streamsV2(
      input: {
        limit: 10
        direction: ASC
        orderBy: ScheduleDate
        streamStatus: [Active, Scheduled, Ended]
        storeStatus: Active
        searchTerm: $search
        withCopies: false
      }
    ) {
      entities {
        id
        name
        slug
        imageURL
        price
        isFree
        streamStatus
        scheduleDate
        type
        isHidden
        repeatsEveryEnum
        isPurchased
        timeZone {
          tzCode
          offset
        }
        store {
          id
          firstName
          lastName
          slug
          storeDetails {
            storeName
          }
        }
      }
    }
    getMerchProducts(
      input: { orderBy: Date, direction: DESC, limit: 10, searchTerm: $search }
    ) {
      entities {
        id
        title
        slug
        minPrice
        createdAt
        mainImageUrl
        store {
          id
          slug
          storeDetails {
            id
            storeName
          }
        }
      }
    }
    getMemorabilia(
      input: {
        orderBy: createdAt
        direction: DESC
        limit: 10
        searchTerm: $search
        statuses: [Active]
      }
    ) {
      entities {
        id
        title
        slug
        price
        createdAt
        memorabiliaProductType
        images {
          id
          url
          isMainImage
        }
        store {
          id
          slug
          storeDetails {
            id
            storeName
          }
        }
      }
    }
    getExperiences(
      input: {
        orderBy: createdAt
        direction: DESC
        limit: 10
        searchTerm: $search
        storeStatuses: [Active]
        statuses: [Active]
      }
    ) {
      entities {
        id
        title
        slug
        price
        mainImageUrl
        store {
          id
          slug
          storeDetails {
            id
            storeName
          }
        }
      }
    }
    getMediaPosts(
      input: {
        direction: DESC
        orderBy: publishedAt
        limit: 10
        searchTerm: $search
        storeStatuses: [Active]
      }
    ) {
      entities {
        id
        title
        slug
        store {
          id
          slug
          storeDetails {
            id
            storeName
          }
        }
        ... on ImagePost {
          mainImageUrl
        }
        ... on VideoPost {
          videoThumbnailUrl: thumbnailUrl
        }
      }
    }
  }
`;
